import { createRouter, createWebHistory } from 'vue-router';
import ApplicationsView from '../views/ApplicationsView.vue';
import ApplicationModal from '../components/ApplicationModal.vue';
import ApplicationView from '../views/ApplicationView.vue';
import ArchiveView from '../views/ArchiveView.vue';
import SubletApplicationsView from '../views/sublet/SubletApplicationsView.vue';
import SubletApplicationView from '../views/sublet/SubletApplicationView/SubletApplicationView.vue';
import SubletArchive from '../views/sublet/SubletArchive.vue';
import OvApplicationsView from '../views/overlatelser/OvApplicationsView.vue';
import OvApplicationView from '../views/overlatelser/OvApplicationView/OvApplicationView.vue';
import OvArchive from '../views/overlatelser/OvArchive.vue';
//import churnService from '@/utils/churn360';
import LogoutView from '@/views/LogoutView.vue';
import StatisticsView from '../views/StatisticsView.vue';
import AnalyticsView from '../views/AnalyticsView.vue';
import SettingsView from '../views/SettingsView.vue';
import SupportView from '../views/SupportView.vue';
import NotFound from '../views/NotFound.vue';
import Forvaltare from '../views/Forvaltare.vue';

import { getLocalStorage, getQueryParams } from '@/utils/windowUtils';
import { APP_NAMES, APP_PATHS } from '@/utils/constants';

const routes = [
  {
    path: '/logga-ut',
    name: 'logout',
    component: LogoutView
  },
  {
    path: '/byten/arkiv',
    name: 'archive',
    component: ArchiveView,
    meta: {
      baRoute: true
    },
    children: [
      {
        path: ':id',
        component: ApplicationModal,
        meta: {
          baRoute: true
        },
        props: {
          component: ApplicationView
        }
      }
    ]
  },
  {
    path: '/forvaltare',
    component: Forvaltare
  },
  {
    path: '/byten/alla',
    component: ApplicationsView,
    meta: {
      baRoute: true
    },
    children: [
      {
        path: ':id',
        component: ApplicationModal,
        meta: {
          baRoute: true
        },
        props: {
          component: ApplicationView
        }
      }
    ]
  },
  {
    path: '/byten/',
    redirect: '/byten/alla',
    meta: {
      baRoute: true
    }
  },
  {
    path: `/${APP_PATHS.ANDRAHAND}/`,
    redirect: `/${APP_PATHS.ANDRAHAND}/alla`,
    meta: {
      ahRoute: true
    }
  },
  {
    path: `/${APP_PATHS.ANDRAHAND}/alla`,
    component: SubletApplicationsView,
    meta: {
      ahRoute: true
    },
    children: [
      {
        path: ':id',
        component: ApplicationModal,
        meta: {
          ahRoute: true
        },
        props: {
          component: SubletApplicationView
        }
      }
    ]
  },
  {
    path: `/${APP_PATHS.ANDRAHAND}/arkiv`,
    name: 'subletArchive',
    component: SubletArchive,
    meta: {
      ahRoute: true
    },
    children: [
      {
        path: ':id',
        component: ApplicationModal,
        meta: {
          ahRoute: true
        },
        props: {
          component: SubletApplicationView
        }
      }
    ]
  },
  {
    path: `/${APP_PATHS.ANDRAHAND}/statistik`,
    redirect: '/statistik'
  },
  {
    path: `/${APP_PATHS.OVERLATELSER_PRIVATE}/`,
    redirect: `/${APP_PATHS.OVERLATELSER_PRIVATE}/alla`,
    meta: {
      ovPrivateRoute: true
    }
  },
  {
    path: `/${APP_PATHS.OVERLATELSER_PRIVATE}/alla`,
    component: OvApplicationsView,
    meta: {
      ovPrivateRoute: true
    },
    children: [
      {
        path: ':id',
        component: ApplicationModal,
        meta: {
          ovPrivateRoute: true
        },
        props: {
          component: OvApplicationView
        }
      }
    ]
  },
  {
    path: `/${APP_PATHS.OVERLATELSER_PRIVATE}/arkiv`,
    name: 'ovPrivateArchive',
    component: OvArchive,
    meta: {
      ovPrivateRoute: true
    },
    children: [
      {
        path: ':id',
        component: ApplicationModal,
        meta: {
          ovPrivateRoute: true
        },
        props: {
          component: OvApplicationView
        }
      }
    ]
  },
  {
    path: `/${APP_PATHS.OVERLATELSER_COMPANY}/`,
    redirect: `/${APP_PATHS.OVERLATELSER_COMPANY}/alla`,
    meta: {
      ovCompanyRoute: true
    }
  },
  {
    path: `/${APP_PATHS.OVERLATELSER_COMPANY}/alla`,
    component: OvApplicationsView,
    meta: {
      ovCompanyRoute: true
    },
    children: [
      {
        path: ':id',
        component: ApplicationModal,
        meta: {
          ovCompanyRoute: true
        },
        props: {
          component: OvApplicationView
        }
      }
    ]
  },
  {
    path: `/${APP_PATHS.OVERLATELSER_COMPANY}/arkiv`,
    name: 'ovCompanyArchive',
    component: OvArchive,
    meta: {
      ovCompanyRoute: true
    },
    children: [
      {
        path: ':id',
        component: ApplicationModal,
        meta: {
          ovCompanyRoute: true
        },
        props: {
          component: OvApplicationView
        }
      }
    ]
  },
  {
    path: '/statistik',
    redirect: '/statistik/allt'
  },
  {
    path: '/statistik/:category',
    name: 'statistics',
    component: StatisticsView
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: AnalyticsView,
    beforeEnter: (to, from) => {
      return from.fullPath && from.fullPath !== '/' ? from.fullPath : '/';
    }
  },
  {
    path: '/installningar',
    name: 'settings',
    component: SettingsView
  },
  {
    path: '/support',
    name: 'support',
    component: SupportView
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes
});

function getNextPath(app, applicationId) {
  if (applicationId) {
    return `/${app}/alla/${applicationId}`;
  } else {
    return `/${app}/alla`;
  }
}

function getAppPath(appName) {
  switch (appName) {
    case APP_NAMES.BYTESANSOKAN:
      return APP_PATHS.BYTESANSOKAN;
    case APP_NAMES.ANDRAHAND:
      return APP_PATHS.ANDRAHAND;
    case APP_NAMES.OVERLATELSER_PRIVATE:
      return APP_PATHS.OVERLATELSER_PRIVATE;
    case APP_NAMES.OVERLATELSER_COMPANY:
      return APP_PATHS.OVERLATELSER_COMPANY;
    default:
      return '';
  }
}

router.beforeEach(async to => {
  if (to.path !== '/') return true;

  const LAST_ACTIVE_APP =
    getLocalStorage('BA_ACTIVE_APP') || APP_NAMES.BYTESANSOKAN;
  const { applicationId, app } = getQueryParams();

  const KNOWN_APPS = [
    APP_NAMES.OVERLATELSER_PRIVATE,
    APP_NAMES.OVERLATELSER_COMPANY,
    APP_NAMES.ANDRAHAND,
    APP_NAMES.BYTESANSOKAN
  ];

  if (KNOWN_APPS.includes(app)) {
    return getNextPath(getAppPath(app), applicationId);
  }
  if (KNOWN_APPS.includes(LAST_ACTIVE_APP)) {
    return getNextPath(getAppPath(LAST_ACTIVE_APP), applicationId);
  }
  return true;
});

export default router;
